module.exports = "<div >\n  <div class=\"row\">\n    <div class=\"column small-12\">\n      <div class=\"column-inner\">\n        <div class=\"page__404\">\n          <b>Désolé, la page demandée</b>\n          <span>n'est pas disponible.</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/page-not-found/page-not-found.component.html
// module id = ./src/app/screens/page-not-found/page-not-found.component.html
// module chunks = main